import store from '@/store';
import { hasAnyRole } from './helpers';

/**
 * Guard for role-based routes.
 * - If the user is not authorized → returns a route location object for the 403 view.
 * - If the user is authorized → returns null (navigation continues).
 */
export const authorized = (authorization) => {
  if (!authorization) {
    return { name: '403' };
  }
  return null;
};

/**
 * Guard that allows access if the user has at least one of the required roles.
 * - If the user is not authorized → returns a route location object for the 403 view.
 * - If the user is authorized → returns null (navigation continues).
 */
export const requireAnyRole = (roles) => {
  if (!hasAnyRole(store.getters['auth/roles'], roles)) {
    return { name: '403' };
  }
  return null;
};
